export const DEFAULT_FIELD_MENU_ITEMS = [
  {
    label: "SHA1",
    value: "sha1",
    disabled: true
  },
  {
    label: "SHA256",
    value: "sha256"
  },
  {
    label: "MD5",
    value: "md5"
  },
  {
    label: "Classification",
    value: "classification"
  },
  {
    label: "Risk Score",
    value: "riskscore"
  },
  {
    label: "First Seen",
    value: "firstseen"
  },
  {
    label: "First Seen Cloud",
    value: "first_seen_cloud"
  },
  {
    label: "Threat",
    value: "threatname"
  },
  {
    label: "Name",
    value: "filename"
  },

  {
    label: "Last Submitted",
    value: "lastsubmitted"
  },

  {
    label: "Username",
    value: "username"
  },
  {
    label: "Format",
    value: "sampletype"
  },
  {
    label: "Files",
    value: "filecount"
  },

  {
    label: "Size",
    value: "size"
  },
  {
    label: "Available",
    value: "available"
  },

  {
    label: "Last Seen",
    value: "lastseen"
  },
  {
    label: "Community Detections",
    value: "threat-reputation"
  }
];

export const DEFAULT_FORMAT_MENU_ITEMS = [
  {
    label: "CSV",
    value: "csv"
  },
  {
    label: "JSON",
    value: "json"
  },
  {
    label: "XML",
    value: "xml"
  }
];

export const exportScopeValues = {
  PAGE: "page",
  SELECTED: "selected"
};

export const exportScopeOptionItems = [
  {
    value: exportScopeValues.PAGE,
    label: "Whole Page",
    bulkLabel: "All Samples"
  },
  { value: exportScopeValues.SELECTED, label: "Selected Samples" }
];
